import axios from '../axios'

/*
 * 推广列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/member/selectPromotionPage',
        method: 'post',
        data
    })
}
export const add = (data) => {
    return axios({
        url: '/promotionSettlementRatioSetting/add',
        method: 'post',
        data
    })
}

export const batchApproveQrcode = (data) => {
    return axios({
        url: '/member/batchApproveQrcode',
        method: 'post',
        data
    })
}


export const manualSet = (data) => {
    return axios({
        url: '/promotionSettlementRatioSetting/manualSet',
        method: 'post',
        data
    })
}

export const getHistory = (params) => {
    return axios({
        url: '/promotionSettlementRatioSetting/getHistory',
        method: 'get',
        params
    })
}







// WEBPACK FOOTER //
// ./src/http/cms/market.js